import { defineStore } from "pinia";

export const useConfigStore = defineStore("config", {
    state: () => ({
        userID: null,
        userFirstName: null,
        userLastName: null,
        token: null,
        isCollapsed: false           
    }),
    persist: {
        enabled: true,
        strategies: [
            {
                key: "auth",
                storage: localStorage,
            },
        ],
    },
    actions: {

        setToken(token) {
            this.token = token;
            // this.authHeader = { 
            //   "Content-Type": "application/json" ,
            //   "Authorization": "Bearer "+token
            // };
        },

        login(user, token) {
            this.userID = user.userID;
            this.userFirstName = user.userFirstName;
            this.userLastName = user.userLastName;
            this.token = token;
            // this.authHeader = { 
            //   "Content-Type": "application/json" ,
            //   "Authorization": "Bearer "+token
            // };
        },
        logout() {
            this.userID = null;
            this.userFirstName = null;
            this.userLastName = null;
            this.token = null;
            // this.authHeader = null;
        },
        toggleNaviCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
    },
    getters: {
        isLoggedIn: (state) => !!state.userID && !!state.token,
        authOnly: (state) => {
            return state.token ? { "Authorization": `Bearer ${state.token}` } : {};
        },
        authHeader: (state) => {
            if (!state.token) return {}; 
            return {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${state.token}`
            };
        }       
    },  
    


});